const LightThemeColors = [
  {
    name: 'RED_THEME',
    palette: {
      primary: {
        main: '#CC0000',
        light: '#FFE6E6',
        dark: '#990000',
        contrastText: '#ffffff',
      },
      secondary: {
        main: '#49BEFF',
        light: '#FFE6E6',
        dark: '#23afdb',
        contrastText: '#ffffff',
      },
    },
  }
];

export { LightThemeColors };
